/* eslint-disable  @typescript-eslint/no-explicit-any */
import {
  MainState,
  Area,
  Zone,
  Report,
  Client,
  Project, Locations
} from "@/interfaces/interfaces";
import moment from "moment";
import { createStore } from "pinia";
import orderBy from "lodash/orderBy";
// import { db } from "../firebase/firebase";
export const useMainStore = createStore({
  // name of the store
  // it is used in devtools and allows restoring state
  id: "main",
  // a function that returns a fresh state

  state: () =>
    ({
      showBatchForm: false,
      showProjectSelect: false,
      // name: "Eduardo",
      // inspectionAreasCollection: db.collection("inspectionAreas"),
      areasArray: {},
      zonesArray: {},
      locationsArray: {},
      inspectionAreas: [],
      inspectionZones: [],
      locations: [] as Locations[],
      projectSurvey: [],
      projectName: "projectOne",
      surveyProgress: true,

      clients: [] as Client[],
      clientId: "",
      clientData: {
        id: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        country: "Nigeria",
        state: "Rivers",
        LGA: "Port-Harcourt",
        mobile: "",
        email: "",
        registrationDate: moment().format("YYYY-MM-DD")
      } as Client,
      projects: [] as Project[],
      projectId: "",
      projectData: {
        id: "",
        clientId: "",
        name: "",
        rigName: '',
        description: "",
        projectDate: moment().format("YYYY-MM-DD")
      } as Project,
      reportId: "",
      reports: [],
      reportData: {
        id: "",
        photo: "",
        inspectionArea: "",
        inspectionZone: "",
        description: "",
        inspectionLocation: "",
        primarySecuring: "",
        secondaryRetention: "",
        howToInspect: "",
        condition: "",
        comments: "",
        control: "",
        reference: ""
      } as Report
    } as MainState),
  // optional getters
  getters: {
    orderAreas: (state) => {
      return orderBy(state.inspectionAreas, ["area"], ["asc"]);
    },
    orderZones: (state) => {
      return orderBy(state.inspectionZones, ["zone"], ["asc"]);
    },
    orderLocations: (state) => {
      return orderBy(state.locations, ["location"], ["asc"]);
    },
    orderSurveys: (state) => {
      // console.log(state.projectSurvey);
      return Object.freeze(
        orderBy(state.projectSurvey, ["reference"], ["asc"])
      );
    },
    doubleCount: (state) => state.projectName,
    // use getters in other getters
    // doubleCountPlusOne: (state, { doubleCount }) => doubleCount.value * 2
    xLocations: (state) => {
      return state.locations.reduce((accumulator, item) => {
        // const f: Array<any> = [];
        const id = item.id as string;
        accumulator[id] = item;
        return accumulator;
      }, {} as any);
    },
    xAreas: (state): object => {
      return state.inspectionAreas.reduce((accumulator, item) => {
        // const f: Array<any> = [];
        const id = item.id as string;
        accumulator[id] = item;
        return accumulator;
      }, {} as any);
    },
    xZones: (state) => {
      return state.inspectionZones.reduce((accumulator, item) => {
        // const f: Array<any> = [];
        const id = item.id as string;
        accumulator[id] = item;
        return accumulator;
      }, {} as any);
    },
    projectdata: (state) => state.projectData
  },
  // optional actions
  actions: {
    resetClientData() {
      console.log(this.state);
      // form.value.reset();
      this.state.clientData = {
        id: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        country: "Nigeria",
        state: "Rivers",
        LGA: "Port-Harcourt",
        mobile: "",
        email: "",
        registrationDate: moment().format("YYYY-MM-DD")
      };
    },
    resetProjectData() {
      console.log(this.state);
      // form.value.reset();
      this.state.projectData = {
        id: "",
        clientId: "",
        name: "",
        rigName: '',
        description: "",
        projectDate: moment().format("YYYY-MM-DD")
      } as Project;
    },
    resetReportData() {
      console.log(this.state);
      // form.value.reset();
      this.state.reportData = {
        id: "",
        photo: "",
        inspectionArea: "",
        inspectionZone: "",
        description: "",
        inspectionLocation: "",
        primarySecuring: "",
        secondaryRetention: "",
        howToInspect: "",
        condition: "",
        comments: "",
        control: "",
        reference: ""
      } as Report;
    },
    updateAreas(
      areaCollection,
      zoneCollection,
      locationCollection,
      surveyCollection
    ) {
      const startProcessing = () => {
        console.log("starting processing");
        const projectData = {
          companyName: "xyz Company",
          rigName: "TTXGG",
          surveys: { areasList: [] }
        };
        projectData.surveys.areasList = [];

        //AREAS
        this.orderAreas.value.forEach((item: Area) => {
          //ZONES
          const zones = [] as Zone[];
          this.orderZones.value.forEach((item: Zone) => {
            //SURVEYS
            const surveys = [] as Report[];
            this.orderSurveys.value.forEach((item: Report) => {
              surveys.push(item);
            });
            const content2 = { ...item, surveys: surveys };
            //CHECK IF HAS FAILED, SURVEY OR INSPECTION
            // if (){
            zones.push(content2);
            // }
          });

          const content = { ...item, zones: zones };
          //@ts-ignore
          projectData.surveys.areasList.push(content);

          // console.log("process---", item);
        });

        // this.state.projectData = Object.freeze(projectData);

        console.log(JSON.stringify(this.state.projectData, null, 2));
      };

      const getData = async () => {
        //GET AREA DATA
        console.log("starting area");
        const areaDoc = await areaCollection.orderBy("area", "asc").get();
        await areaDoc.forEach((item: any) => {
          const obj = { id: item.id, ...item.data() };
          this.state.inspectionAreas.push(obj);
        });
        // console.log(this.state.inspectionAreas);

        //GET ZONE DATA
        console.log("starting zone");
        const zoneDoc = await zoneCollection.orderBy("zone", "asc").get();
        await zoneDoc.forEach((item: any) => {
          const obj = { id: item.id, ...item.data() };
          this.state.inspectionZones.push(obj);
        });
        // console.log(this.state.inspectionZones);

        //GET LOCATION DATA
        console.log("starting location");
        const locationDoc = await locationCollection
          .orderBy("location", "asc")
          .get();
        await locationDoc.forEach((item: any) => {
          const obj = { id: item.id, ...item.data() };
          this.state.locations.push(obj);
        });
        // console.log(this.state.locations);

        //GET SURVEY DATA
        console.log("starting survey");
        const surveyDoc = await surveyCollection
          .orderBy("reference", "asc")
          .get();
        await surveyDoc.forEach((item: any) => {
          const obj = { id: item.id, ...item.data() };
          this.state.projectSurvey.push(obj);
        });
        // console.log(this.state.projectSurvey);

        await startProcessing();
      };
      getData();
    }
  }
});
